import Vue from "vue";
import axios from "axios";
import {reactive, toRefs, provide, inject} from "@vue/composition-api";
import {useLoading} from "./loading";
import {$t} from "@/i18n";
import {actions as errorActions} from "@/store/modules/error";
import {actions as dialogActions} from "@/store/modules/dialog";
import {client_settings} from "@/api";

const {startLoading, finishLoading} = useLoading("plugins");

export const state = reactive({});

export const actions = {
    fetchAllApps({company_id}) {
        return new Promise(function (resolve, reject) {
            let url = Vue.config.url_prefix + "/api/a/{0}/all_features".format(company_id);
            axios
                .get(url)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    fetchApp({company_id, feature_id_or_name}) {
        return new Promise(function (resolve, reject) {
            let url = Vue.config.url_prefix + "/api/a/{0}/feature/{1}".format(company_id, feature_id_or_name);
            axios
                .get(url)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    execAppAction({account_id, feature_id, action, data}) {
        return new Promise(function (resolve, reject) {
            let url = Vue.config.url_prefix + "/api/a/{0}/features/{1}/{2}".format(account_id, feature_id, action);
            axios
                .post(url, data === undefined ? null : data)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },

    async getClientSettings(client_id, feature_id) {
        startLoading("getClientSettings");
        try {
            return await client_settings.get(client_id, feature_id);
        } finally {
            finishLoading("getClientSettings");
        }
    },
    async saveClientSettings(client_id, feature_id, data) {
        let response;
        try {
            errorActions.clear_validation_errors();
            startLoading("saveClientSettings");
            response = await client_settings.post(client_id, feature_id, data);
        } catch (err) {
            //pass
        } finally {
            finishLoading("saveClientSettings");
        }
        return response;
    },
    async deleteClientSettings(client_id, feature_id) {
        let response;
        try {
            errorActions.clear_validation_errors();
            startLoading("deleteClientSettings");
            response = await client_settings.delete(client_id, feature_id);
        } catch (err) {
            //pass
        } finally {
            finishLoading("deleteClientSettings");
        }
        return response;
    },
    async testClientSettings(client_id, feature_id, data) {
        let response;
        try {
            errorActions.clear_validation_errors();
            startLoading("testClientSettings");
            response = await client_settings.test(client_id, feature_id, data);
            dialogActions.setConfirmOptions({
                title: $t("Connection successful!"),
                confirm_text: $t("Ok")
            });
            dialogActions.openConfirmDialog();
        } catch (err) {
            //pass
        } finally {
            finishLoading("testClientSettings");
        }
        return response;
    },
    /*
    async runClientIntegration(client_id_list, feature_id, data) {
        let response;
        try {
            errorActions.clear_validation_errors();
            startLoading("runClientIntegration");
            response = await client_settings.run(client_id_list, feature_id, data);
        } catch (err) {
            //pass
        } finally {
            finishLoading("runClientIntegration");
        }
        return response;
    },
     */
};

export const key = Symbol("FeatureModule");

export const provideFeature = () => {
    provide(key, {
        ...toRefs(state),
        ...actions
    });
};

export default () => inject(key);
